// 模組06 監控 — mock 種子資料（DCK-06-01 硬體存活狀態,Figma 2128:28647）。
//
// 正式版資料來自監控系統介接(WhatsUp Gold),不是本系統的 CRUD 資源;
// mock 給一份自帶顯示欄位的清單,之後整條換成真 API 即可,不跟資產模組的
// hardware 種子硬綁(監控回報的設備範圍與資產台帳本來就可能不一致)。
//
// 依設計稿註記「目前派工尚未規劃流程,預期會將派工相關資料都移除」:
// 種子不含 維修狀態(報修中/派工中/尚未派工)等派工欄位,見
// .scratch/DCK-06監控/issues/01-派工相關待確認.md。
//
// deviceStatus:up(存活)/down(失聯)/maintenance(維護中) — 對齊特別關注卡的三個統計。
// starred:特別關注(列表最前面帶星,與智慧看板/硬體列表的 ★ 同語彙)。
// retired:已廢除(WF_v3 調整:預設隱藏,可切「顯示已廢除資料」;票 21)。
//   明確寫 false 而不是省略 —— 預設過濾走 crudFactory 等值參數 retired=false,
//   缺欄位的列會被過濾掉(值語意)。

const manager = (name, employeeId, dept, title, email, ext) =>
  ({ name, employeeId, dept, title, email, ext });
const vendor = (name, contact, phone, ext) => ({ name, contact, phone, ext });

export const monitorDevices = [
  {
    id: 1,
    retired: false,
    code: "SW-0012",
    hostname: "核心服務主機",
    ip: "10.10.30.2",
    brand: "Cisco",
    model: "Catalyst 9500",
    roomName: "台北內湖機房",
    cabinetCode: "R-A01",
    uLabel: "U40",
    deviceStatus: "up",
    starred: true,
    // 詳細資訊抽屜(2128:29068)
    propertyNo: "SW-B02-011",
    assetName: "匯聚交換器",
    assetType: "網路相關",
    assetCode: "AST-2025-0090",
    serialNo: "FOC2401Y2AB",
    hwVersion: "IOS-XE 17.9.4",
    fwVersion: "16.12.05",
    os: "IOS-XE",
    manager: manager("林承翰", "EMP0145", "資訊處", "系統管理師", "yt.chen@chainwe.com", "1122"),
    vendor: vendor("ＸＸＸ廠商", "王小明", "02-22222222", "1122"),
  },
  {
    id: 2,
    retired: false,
    code: "SW-0018",
    hostname: "備援防火牆",
    ip: "10.10.30.6",
    brand: "Fortinet",
    model: "FortiGate 600E",
    roomName: "台北內湖機房",
    cabinetCode: "R-A01",
    uLabel: "U36",
    deviceStatus: "up",
    starred: true,
    propertyNo: "FW-B02-003",
    assetName: "備援防火牆",
    assetType: "網路相關",
    assetCode: "AST-2025-0102",
    serialNo: "FGT60E4Q17000123",
    hwVersion: "FortiOS 7.4.3",
    fwVersion: "7.4.3-b2573",
    os: "FortiOS",
    manager: manager("林承翰", "EMP0145", "資訊處", "系統管理師", "yt.chen@chainwe.com", "1122"),
    vendor: vendor("ＸＸＸ廠商", "王小明", "02-22222222", "1122"),
  },
  {
    id: 3,
    retired: false,
    code: "SRV-A01-001",
    hostname: "AP 伺服器 01",
    ip: "10.10.32.15",
    brand: "Dell",
    model: "PowerEdge R750",
    roomName: "台北內湖機房",
    cabinetCode: "R-A02",
    uLabel: "U10",
    deviceStatus: "down",
    starred: false,
    propertyNo: "SRV-B01-001",
    assetName: "AP 伺服器",
    assetType: "系統相關",
    assetCode: "AST-2025-0031",
    serialNo: "CN7X2K3",
    hwVersion: "iDRAC 6.10.30",
    fwVersion: "2.15.0",
    os: "RHEL 9",
    manager: manager("陳雅芳", "EMP0102", "資訊處", "維運工程師", "yf.chen@chainwe.com", "1305"),
    vendor: vendor("ＸＸＸ廠商", "王小明", "02-22222222", "1122"),
  },
  {
    id: 4,
    retired: false,
    code: "SRV-A01-002",
    hostname: "DB 伺服器 01",
    ip: "10.10.32.16",
    brand: "HPE",
    model: "ProLiant DL380",
    roomName: "新北新莊機房",
    cabinetCode: "R-B01",
    uLabel: "U20",
    deviceStatus: "down",
    starred: false,
    propertyNo: "SRV-B01-002",
    assetName: "DB 伺服器",
    assetType: "系統相關",
    assetCode: "AST-2025-0032",
    serialNo: "SGH820XY12",
    hwVersion: "iLO 5 2.95",
    fwVersion: "U30 v2.68",
    os: "Windows Server 2022",
    manager: manager("陳雅芳", "EMP0102", "資訊處", "維運工程師", "yf.chen@chainwe.com", "1305"),
    vendor: vendor("ＹＹＹ廠商", "李大同", "02-33333333", "2201"),
  },
  {
    id: 5,
    retired: false,
    code: "SRV-A01-004",
    hostname: "監控伺服器",
    ip: "10.10.32.18",
    brand: "Lenovo",
    model: "ThinkSystem SR650",
    roomName: "新北新莊機房",
    cabinetCode: "R-B01",
    uLabel: "U12",
    deviceStatus: "maintenance",
    starred: false,
    propertyNo: "SRV-B01-004",
    assetName: "監控伺服器",
    assetType: "系統相關",
    assetCode: "AST-2025-0034",
    serialNo: "J301A2BC",
    hwVersion: "XCC 4.10",
    fwVersion: "IVE156O-3.10",
    os: "Ubuntu 22.04",
    manager: manager("張志明", "EMP0230", "資訊處", "網路工程師", "cm.chang@chainwe.com", "1410"),
    vendor: vendor("ＹＹＹ廠商", "李大同", "02-33333333", "2201"),
  },
  {
    id: 6,
    retired: false,
    code: "SW-0021",
    hostname: "出口路由器",
    ip: "10.10.30.1",
    brand: "Cisco",
    model: "ASR 1001-X",
    roomName: "桃園青埔機房",
    cabinetCode: "R-C01",
    uLabel: "U42",
    deviceStatus: "up",
    starred: false,
    propertyNo: "RT-C01-001",
    assetName: "出口路由器",
    assetType: "網路相關",
    assetCode: "AST-2025-0110",
    serialNo: "FXS2130Q1ZD",
    hwVersion: "IOS-XE 17.6.5",
    fwVersion: "17.6.5a",
    os: "IOS-XE",
    manager: manager("張志明", "EMP0230", "資訊處", "網路工程師", "cm.chang@chainwe.com", "1410"),
    vendor: vendor("ＸＸＸ廠商", "王小明", "02-22222222", "1122"),
  },
  {
    id: 7,
    retired: false,
    code: "SW-0022",
    hostname: "樓層交換器 3F",
    ip: "10.10.30.13",
    brand: "Cisco",
    model: "Catalyst 9300",
    roomName: "桃園青埔機房",
    cabinetCode: "R-C01",
    uLabel: "U38",
    deviceStatus: "up",
    starred: false,
    propertyNo: "SW-C01-002",
    assetName: "樓層交換器",
    assetType: "網路相關",
    assetCode: "AST-2025-0111",
    serialNo: "FOC2233X0AB",
    hwVersion: "IOS-XE 17.9.4",
    fwVersion: "17.9.4a",
    os: "IOS-XE",
    manager: manager("張志明", "EMP0230", "資訊處", "網路工程師", "cm.chang@chainwe.com", "1410"),
    vendor: vendor("ＸＸＸ廠商", "王小明", "02-22222222", "1122"),
  },
  {
    id: 8,
    retired: false,
    code: "SRV-B02-002",
    hostname: "檔案伺服器",
    ip: "10.10.33.8",
    brand: "Dell",
    model: "PowerEdge R650",
    roomName: "台北內湖機房",
    cabinetCode: "R-A02",
    uLabel: "U16",
    deviceStatus: "up",
    starred: false,
    propertyNo: "SRV-B02-002",
    assetName: "檔案伺服器",
    assetType: "系統相關",
    assetCode: "AST-2025-0040",
    serialNo: "CN9Y4L1",
    hwVersion: "iDRAC 6.10.30",
    fwVersion: "2.15.0",
    os: "Windows Server 2022",
    manager: manager("陳雅芳", "EMP0102", "資訊處", "維運工程師", "yf.chen@chainwe.com", "1305"),
    vendor: vendor("ＹＹＹ廠商", "李大同", "02-33333333", "2201"),
  },
  {
    id: 9,
    retired: true,
    code: "SW-0003",
    hostname: "汰換核心交換器",
    ip: "10.10.30.250",
    brand: "Cisco",
    model: "Catalyst 4500",
    roomName: "台北內湖機房",
    cabinetCode: "R-A02",
    uLabel: "U02",
    deviceStatus: "down",
    starred: false,
    propertyNo: "SW-B02-001",
    assetName: "核心交換器(已汰換)",
    assetType: "網路相關",
    assetCode: "AST-2020-0003",
    serialNo: "FOC1901X1CD",
    hwVersion: "IOS 15.2",
    fwVersion: "15.2.7",
    os: "IOS",
    manager: manager("林承翰", "EMP0145", "資訊處", "系統管理師", "yt.chen@chainwe.com", "1122"),
    vendor: vendor("ＸＸＸ廠商", "王小明", "02-22222222", "1122"),
  },
];

export default monitorDevices;
